<template lang="html">
  <transition name="popup-t">
    <div
      v-show="active"
      ref="con"
      :class="[`ms-popup-${color}`, classPopup, {'p-t-0': fullscreenx || isSetPaddingTopZero}]"
      class="ms-component con-ms-popup"
      :style="[{zIndex: styleZIndex}]"
      @keydown="handleKeyDown"
    >
      <!-- dvquang2 - bắt short key toàn màn hình -->
      <span
        ref="shortkey"
        v-shortkey="defaultShortKey"
        class="popup-shortkey"
        @shortkey="shortkeyAction"
      />
      <div
        :style="styleCon"
        class="ms-popup--background"
      />
      <div
        ref="popupx"
        :style="[stylePopup, {top: offsetTop}]"
        class="ms-popup flex flex-col"
        :class="{'fullscreen': fullscreenx , 'custom-height' : isActiveCustomHeight}"
      >
        <input
          ref="msInput"
          class="inputHidden"
        >
        <!-- //header -->
        <div :style="{'height': getTotalHeightHeader + 'px'}">
          <header
            :style="styleHeader"
            class="ms-popup--header"
          >
            <div class="ms-popup--title">
              <h2>
                <span
                  :style="styleTitle"
                  style="letter-spacing: .576px"
                >{{ title }}</span>
              </h2>
            </div>
            <div class="hover-show flex justify-between items-center">
              <ms-icon
                v-if="showZoomInBtn"
                :icon="!isExpand ? 'mi-expand': 'mi-collapse'"
                :tooltip-content="!isExpand ? $t('i18nCommon.Expand'): $t('i18nCommon.Collapse')"
                @click="zoomPopup"
              />
            </div>
            </ms-col>
            <div
              v-if="!buttonCloseHidden"
              class="hover-show flex justify-between items-center ms-popup--close-root"
            >
              <ms-icon
                ref="btnclose"
                :icon="iconClose"
                color="#9197af"
                class="ms-popup--close"
                :tooltip-content="'Đóng'"
                @click="close($event,true)"
              />
            </div>
          </header>
          <div
            v-if="subTitle"
            class="ms-popup--subheader"
            :style="styleSubTitle"
          >
            <span style="letter-spacing: .196px;">
              {{ subTitle }}
            </span>
          </div>
        </div>
        <!-- // slots  -->
        <div
          :class="classContent"
          :style="[{'overflow': !isScroll?'auto':'hidden'},styleContent]"
          class="ms-popup--content"
        >
          <slot name="content" />
        </div>

        
        <footer
          v-if="isShowFooter"
          :style="styleFooter"
          class="ms-popup--footer"
          :class="{ 'footer-custom' : isActiveFooterCustom, 'borderFooter': borderFooter }"
        >
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import _color from "./color";
import commonFunction from '../../../../src/commons/commonFunction.js';
export default {
  name: "MsPopup",
  props: {
    isShowFooter: {
      type: Boolean,
      default: true,
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
    color: {
      default: "primary",
      type: String,
    },
    minWidth: {
      default: 500,
      type: [String, Number],
    },

    width: {
      default: 500,
      type: [String, Number],
    },
    height: {
      default: "auto",
      type: [String, Number],
    },
    active: {
      default: false,
      type: Boolean,
    },
    title: {
      default: "popup",
      type: String,
    },
    subTitle: {
      default: "",
      type: String,
    },
    buttonCloseHidden: {
      default: false,
      type: Boolean,
    },
    fullscreen: {
      default: false,
      type: Boolean,
    },
    backgroundColor: {
      default: null,
      type: String,
    },
    backgroundColorPopup: {
      default: "rgb(255,255,255)",
      type: String,
    },
    classContent: {
      default: null,
      type: String,
    },
    iconClose: {
      default: "mi-close-2",
      type: String,
    },
    showZoomInBtn: {
      type: [String, Boolean],
      default: false,
    },
    showZoomOutBtn: {
      type: [String, Boolean],
      default: false,
    },
    isActiveFooterCustom: {
      type: [String, Boolean],
      default: false,
    },
    isActiveCustomHeight: {
      type: [String, Boolean],
      default: false,
    },
    isActivePopup: {
      type: [String, Boolean],
      default: true,
    },
    zoomOut: {
      type: [String, Boolean, Number],
      default: false,
    },
    paddingBottomHeader: {
      type: [String, Number],
      default: null,
    },

    paddingBottomContent:{
      type: Boolean,
      default: true
    },

    backgroundHeader: {
      type: String,
      default: "",
    },
    heightHeader: {
      type: [String, Number],
      default: 53,
    },
    heightSubHeader: {
      type: [String, Number],
      default: 25,
    },
    heightFooter: {
      type: [String, Number],
      default: "fit-content",
    },
    heightContent: {
      type: [String, Number],
      default: null,

    },
    lineHeightContent: {
      type: [String, Number],
      default: null,
    },
    fontSizeTitle: {
      type: [String, Number],
      default: null,
    },
    colorTitle: {
      default: "#212121",
      type: String,
    },
    fontSizeSubTitle: {
      type: [String, Number],
      default: null,
    },
    colorSubTitle: {
      type: String,
      default: "#666666",
    },
    borderFooter: {
      type: Boolean,
      default: true,
    },
    // set thứ tự cho popup (trong trường hợp nhiều popup)
    // pdthien 26.02.2021
    order: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: Number,
      default: 100,
    },
    offsetTop: {
      type: String,
      default: '',
    },
    //Xét Class cho popup
    classPopup: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fullscreenx: this.fullscreen,
      isExpand: false,
      isSetPaddingTopZero: false,
      defaultShortKey: {
        Close: ['esc'], //Đóng
        Maximum: ['ctrl', 'space'],  //phóng to thu nhỏ form
      },
    };
  },
  computed: {
    
    /**
     * style z-index
     */
    styleZIndex() {
      return this.zIndex + this.order;
    },
    /**
     * Set style cho title
     * NVHieu 11/12/2020
     */
    styleTitle() {
      return {
        fontSize:
          this.fontSizeTitle != null ? this.fontSizeTitle + "px" : "24px",
        color: this.colorTitle,
      };
    },
    styleHeader() {
      return {
        color: _color.getColor(this.color, 1),
        paddingBottom:
          this.paddingBottomHeader != null
            ? this.paddingBottomHeader + "px"
            : "auto",
        background:
          this.backgroundHeader != null ? this.backgroundHeader : "auto",
        height: !isNaN(this.heightHeader)
          ? this.heightHeader + "px"
          : this.heightHeader,
      };
    },
    /**
     * Tính height khi có subTitle
     * pdthien 23/1/2021
     */
    styleSubTitle() {
      if (!this.subTitle) return 0;
      return {
        height: !isNaN(this.heightSubHeader)
          ? this.heightSubHeader + "px"
          : this.heightSubHeader,
      };
    },
    getTotalHeightHeader() {
      if (!this.subTitle) return this.heightHeader;
      return this.heightHeader + this.heightSubHeader;
    },
    styleContent() {
      return {
        height: `calc(100% - ${
          this.getTotalHeightHeader +  this.isShowFooter == false ? 0 : this.heightFooter
        }px)`,
        lineHeight:
          this.lineHeightContent != null
            ? this.lineHeightContent + "px"
            : "auto",
        paddingBottom:
          this.paddingBottomContent ? "" : "unset"
      };
    },
    styleFooter() {
      return {
        height: this.isShowFooter == false
            ? 0
            : this.heightFooter != "fit-content"
            ? this.heightFooter + "px"
            : this.heightFooter,
      };
    },
    styleAfter() {
      return {
        background: _color.getColor(this.color, 1),
      };
    },
    styleCon() {
      return {
        background: _color.getColor(this.backgroundColor, 1),
      };
    },
    stylePopup() {
      return {
        background: _color.getColor(this.backgroundColorPopup, 1),
        width: !isNaN(this.width) ? this.width + "px" : this.width,
        minWidth: !isNaN(this.minWidth) ? this.minWidth + "px" : this.minWidth,
        height: !isNaN(this.width) ? this.height + "px" : this.height,
      };
    },
  },
  watch: {
    zoomOut(val) {
      if (val == 1) {
        this.zoomInPopup();
      } else if (val == 2) {
        this.fullscreenx = false;
        this.showZoomOutBtn = false;
        this.$emit("onZoomOutPopup", this.fullscreenx);
      }
    },
    active(val) {
      if (val) {
        this.$emit("open");
      }
    },
  },
  created() {
    document.addEventListener("click", this.clickOutside);
  },
  mounted() {
    // add nó vào list view để bắt key - dvquang2
    commonFunction.shortkeyPushView(this.$el);
    this.insertBody();
    if (window.innerHeight - this.$refs.popupx.offsetHeight <= 100) {
      this.isSetPaddingTopZero = true;
    } else {
      this.isSetPaddingTopZero = false;
    }
  },
  beforeDestroy() {
    // close the left open prompt
    let elx = this.$refs.con;
    
    if (document.body) {
      try {
        elx && document.body.removeChild(elx);
      } catch (err) {
        console.log(err.message);
      }
    }
    document.removeEventListener("click", this.clickOutside);
  },
  methods: {
    shortkeyAction(e){
      let me = this;
      switch(e.srcKey){
        case 'Close':
        this.$emit("update:active", false);
        this.$emit("close", false);
        commonFunction.shortkeyPopView(this.$el);
          break;
      }
    },
    giveColor(color) {
      return _color.rColor(color);
    },
    close(event, con) {
      if (con) {
        // this.resetZoomPopup();
        this.$emit("update:active", false);
        this.$emit("close", false);
      }
    },
    zoomPopup() {
      this.isExpand = !this.isExpand;
      if (this.isExpand) {
        this.fullscreenx = true;
        // this.$emit("onZoomInPopup", this.fullscreenx);
      } else {
        this.fullscreenx = false;
        // this.$emit("onZoomOutPopup", this.fullscreenx);
      }
      this.$emit("toggleZoom", this.isExpand);
    },
    /**
     * Đặt popup về zoom out
     * nvhieu 13/1/2021
     */
    resetZoomPopup() {
      if (this.isExpand) {
        this.isExpand = false;
        this.fullscreenx = false;
      }
    },
    insertBody() {
      let elx = this.$refs.con;
      try {
        elx && document.body.insertBefore(elx, document.body.firstChild);
      } catch (err) {
        console.log(err.message);
      }
    },
    handleKeyDown(e) {
      event.stopPropagation();
      if (e.key === "Escape") {
        this.$emit("keyEscape");
      } else if (e.key === "Enter") {
        this.$emit("keyEnter");
      }
    },
    clickOutside() {
      // this.$refs.msInput.focus();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/msPopup.scss";

// .ms-popup.flex.flex-col{
//   width: 70vw !important;
//   height: calc(100vh - 80px) !important;
//   margin: 40px 40px 0px 40px;
// }
// .ms-popup--content{
//   width: 30%;
// }
.ms-popup.fullscreen {
  width: 100vw !important;
  height: 100vh !important;
}
.zoom {
  filter: brightness(1.5);
}
.zoom-out {
  filter: brightness(1.5);
}
.footer-custom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.custom-height {
  min-height: 550px !important;
}
.hover-show {
  &:hover {
    background-color: #eff1f6;
    border-radius: 50%;
  }
}
.borderFooter {
  border-top: 1px solid #dadce3;
}
.inputHidden {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
</style>

